(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_search-input"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
  const input = document.getElementById('SearchPageInput--{{ block.id }}');
  const clearBtn = document.getElementById('clear-search-btn--{{ block.id }}');
  if (!input || !clearBtn) return;

  const toggleClear = () => {
    clearBtn.style.display = input.value.trim() ? 'block' : 'none';
  };

  toggleClear();
  input.addEventListener('input', toggleClear);

  // Автофокус + курсор в конец
  input.focus();
  if (input.value) {
    input.setSelectionRange(input.value.length, input.value.length);
    toggleClear();
  }

  // Живой поиск
  let timer;
  input.addEventListener('input', () => {
    clearTimeout(timer);
    timer = setTimeout(() => input.form.submit(), 400);
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["preorder-button"] && !Shopify.designMode) return;
  try {
    function albastyOpenPreorderMessage() {
    document.querySelectorAll('dialog.preorder-dialog').forEach(function (dialog) {
      if (dialog.querySelector('[data-preorder-open]') && !dialog.open) {
        dialog.showModal();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', albastyOpenPreorderMessage);
  } else {
    albastyOpenPreorderMessage();
  }

  /* Проверка полей ДО капчи.
     Защита Shopify от ботов (hCaptcha) перехватывает отправку формы и отправляет её в обход
     проверки браузера. Поэтому проверяем поля сами, раньше капчи: если что-то заполнено
     неправильно — отправку останавливаем и браузер подсвечивает ошибочное поле. */
  function albastyPreorderBlockInvalid(event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var form = event.type === 'submit' ? target : target.closest('form');
    if (!form || !form.classList || !form.classList.contains('preorder-form')) return;
    if (event.type === 'click' && !target.closest('[type="submit"]')) return;

    if (!form.checkValidity()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      form.reportValidity();
    }
  }

  window.addEventListener('click', albastyPreorderBlockInvalid, true);
  window.addEventListener('submit', albastyPreorderBlockInvalid, true);

  /* Поле телефона: буквы и другие лишние символы не вводятся вообще.
     Разрешены цифры, пробелы, скобки, дефисы и один знак + в самом начале. */
  document.addEventListener('input', function (event) {
    var input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches('.preorder-form input[type="tel"]')) return;

    var cleaned = input.value.replace(/[^\d\s()+\-]/g, '');
    var startsWithPlus = cleaned.trim().charAt(0) === '+';
    cleaned = cleaned.replace(/\+/g, '');
    if (startsWithPlus) cleaned = '+' + cleaned.replace(/^\s+/, '');

    if (cleaned !== input.value) input.value = cleaned;
  });
  } catch(e) { console.error(e); }
})();

})();
